import { useEffect, useState } from 'react';
import HeaderRoutesWithUnderlining from '../HeaderRoutes/HeaderRoutesWithUnderlining';
import { useSelector } from 'react-redux';

const NerisSettingsNav = () => {
  const [step, setStep] = useState();

  const { permissions } = useSelector(
    (state) => state.nerisSettingsAuthoritiesReducer
  );

  const headerLinks = [
    {
      label: 'Neris Report Form',
      link: '/firehouse/neris-settings',
    },
    // {
    //   label: 'Station & Units Settings',
    //   link: '/firehouse/neris-settings/station-and-station-units',
    // },
    {
      label: 'Neris Types',
      link: '/firehouse/neris-settings/groups-and-types',
    },
    {
      label: 'Neris Authorities',
      link: '/firehouse/neris-settings/authorities',
      disable: !permissions.can_assign_roles,
    },
  ];

  useEffect(() => {
    let i = headerLinks.findIndex((x) => {
      return x.link === window.location.pathname;
    });

    setStep(i);
  }, []);

  return (
    <div className="d-flex">
      {step !== undefined && (
        <HeaderRoutesWithUnderlining step={step} steps={headerLinks} />
      )}
    </div>
  );
};

export default NerisSettingsNav;
